<template>
    <div class="toolbar flex align-center justify-space-between">
        <div class="box-left box grow flex">
            <button
                @click="toggleSidebar"
                v-if="menuBurger !== 'right'"
                class="toggle-sidebar card-base card-shadow--small"
            >
                <i class="mdi mdi-menu" />
            </button>
        </div>
        <div class="box-right flex align-center pl-10">
            <search v-if="!readonly" />
            <community-switcher />
            <el-popover
                @show="onOpenNotifications"
                ref="popover"
                placement="bottom"
                :width="popoverWidth"
                trigger="click"
            >
                <notification-box />
            </el-popover>
            <el-badge
                :hidden="unreadNotifications.length === 0"
                :is-dot="true"
                class="notification-icon-badge"
            >
                <el-button
                    title="Notifications"
                    v-popover:popover
                    icon="mdi mdi-bell"
                    class="notification-icon"
                />
            </el-badge>
            <el-badge
                :value="cart.orders.length"
                v-if="
                    current_community &&
                    cart.orders &&
                    hasRoutePermission(Routes.CART)
                "
            >
                <el-button
                    title="Shopping Cart"
                    icon="mdi mdi-cart"
                    class="notification-icon"
                    @click="$router.push({ name: 'Cart' })"
                />
            </el-badge>
            <span class="username" v-if="auth.user">
                <a
                    href="#"
                    @click.prevent="
                        $router.push({ name: Routes.ACCOUNT_DETAILS })
                    "
                    >{{ auth.user.name }}</a
                >
            </span>
            <el-dropdown trigger="click" @command="onCommand">
                <span class="el-dropdown-link">
                    <img
                        src="../../assets/images/avatar-2.jpg"
                        class="avatar"
                        alt="avatar"
                    />
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="/logout">
                        <i class="mdi mdi-logout mr-10" /> Logout
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <form
                method="post"
                ref="formLogout"
                action="/logout"
                style="display: none"
            >
                <input type="hidden" name="_token" :value="csrf" />
            </form>

            <button
                @click="toggleSidebar"
                v-if="menuBurger === 'right'"
                class="toggle-sidebar toggle-sidebar__right card-base card-shadow--small"
            >
                <i class="mdi mdi-menu" />
            </button>
        </div>
    </div>
</template>

<script>
import NotificationBox from "../components/NotificationBox";
//import Search from "@/components/Search";
import CommunitySwitcher from "@/components/CommunitySwitcher";
import { mapState } from "vuex";
import * as Roles from "../constants/roles";
import * as Routes from "../constants/routes";
import auth from "../mixins/auth";
import * as Getters from "../store/constants/getters";
import * as Mutations from "../store/constants/mutations";
import Search from "../views/pages/order/Search";
import { getRoutesUtil } from "./../utils/routes.default";

export default {
    name: "Toolbar",
    mixins: [auth],
    props: ["menuBurger"],
    data() {
        return {
            Routes,
            Getters,
            Roles,
            popoverWidth: 300,
            fullscreen: false,
            lang: "us",
            selected_community: null,
            readonly: true,
            routes_util: null
        };
    },
    computed: {
        ...mapState(["current_community"]),
        unreadNotifications() {
            return this.$store.getters[Getters.GET_UNREAD_NOTIFICATIONS];
        },
        csrf() {
            return this.$store.state.csrf;
        },
        cart() {
            return this.$store.state.cart;
        }
    },
    methods: {
        onCommandLang(lang) {
            if (lang.charAt(0) === "/") this.onCommand(lang);
            else this.lang = lang;
        },
        onCommand(path) {
            if (path === "/logout") {
                this.$refs.formLogout.submit();
            } else {
                this.$router.push(path);
            }
        },
        toggleSidebar() {
            this.$emit("toggle-sidebar");
        },
        resizePopoverWidth() {
            if (window.innerWidth <= 768) {
                this.popoverWidth = 250;
            } else {
                this.popoverWidth = 300;
            }
        },
        toggleFullscreen() {
            this.$fullscreen.toggle(document.querySelector("body"), {
                wrap: false,
                callback: () => {
                    this.fullscreen = this.$fullscreen.getState();
                }
            });
        },
        onOpenNotifications() {
            this.unreadNotifications.forEach((item) => {
                axios
                    .post(`/web-api/notification/${item.id}/mark-as-read`)
                    .then(() => {
                        this.$store.commit(
                            Mutations.MARK_NOTIFICATION_AS_READ,
                            item
                        );
                    });
            });
        },
        getUserType() {
            if (this.$store.state.user) {
                if (
                    this.$store.state.user.roles[0].role ===
                        this.Roles.SUPER_ADMIN ||
                    this.$store.state.user.roles[0].role === this.Roles.ADMIN
                ) {
                    return (this.readonly = false);
                }
            }
        },
        isRouteAccessible(name) {
            return this.routes_util.isRouteAccessible(name);
        },
        hasRoutePermission(routeName) {
            return this.routes_util.hasRoutePermission(routeName);
        }
    },
    components: {
        NotificationBox,
        Search,
        CommunitySwitcher
    },
    mounted() {
        this.fullscreen = this.$fullscreen.getState();
        this.resizePopoverWidth();
        window.addEventListener("resize", this.resizePopoverWidth);
        this.getUserType();
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.resizePopoverWidth);
    },
    created() {
        this.routes_util = getRoutesUtil(this.$router);
    }
};
</script>

<style lang="scss" scoped>
@use "../../assets/scss/mixins" as *;
@use "../../assets/scss/variables" as vars;
@use "sass:color";

.toolbar {
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;

    .username {
        margin-left: 20px;
        font-weight: bold;
        @include text-bordered-shadow();

        a {
            color: vars.$text-color;
            text-decoration: none;

            &:hover {
                color: vars.$text-color-accent;
            }
        }
    }

    .avatar {
        border-radius: 50%;
        width: 35px;
        height: 35px;
        border: 1px solid #fff;
        margin-left: 20px;
        box-sizing: border-box;
        display: block;
        cursor: pointer;
        box-shadow:
            0 2px 5px 0 rgba(49, 49, 93, 0.1),
            0 1px 2px 0 rgba(0, 0, 0, 0.08);
        transition: box-shadow 0.5s;

        &:hover {
            box-shadow:
                0px 3px 10px 0 rgba(49, 49, 93, 0.08),
                0px 2px 7px 0 rgba(0, 0, 0, 0.08);
        }
    }

    .notification-icon {
        font-size: 35px;
        outline: none;
        padding: 0;
        background: transparent;
        border: none;
        margin-left: 20px;
        //color: #aab7c5;
        color: color.adjust(vars.$text-color, $alpha: -0.7);
        @include text-bordered-shadow();

        &:hover {
            color: vars.$text-color-accent;
        }
    }

    .toggle-sidebar {
        border: 1px solid transparent;
        height: 32px;
        min-height: 32px;
        line-height: 32px;
        width: 32px;
        min-width: 32px;
        max-width: 32px;
        box-sizing: border-box;
        text-align: center;
        margin: 0;
        outline: none;
        margin-right: 5px;
        font-size: 24px;
        padding: 0;
        cursor: pointer;
        display: inline-block;
        color: vars.$text-color;
        background: white;
        display: none;
        opacity: 0;
        transition: all 0.5s;

        &__right {
            margin-right: 0px;
            margin-left: 5px;
        }

        &:hover,
        &:focus,
        &:active {
            color: vars.$text-color-accent;
            border-color: vars.$text-color-accent;
        }
    }

    .fullscreen-button {
        font-size: 24px;
        cursor: pointer;
        outline: none;
        padding: 0;
        background: transparent;
        border: none;
        margin-left: 20px;
        //color: #aab7c5;
        color: color.adjust(vars.$text-color, $alpha: -0.7);
        @include text-bordered-shadow();

        &:hover {
            color: vars.$text-color-accent;
        }
    }

    .el-dropdown {
        .flag-icon {
            box-shadow:
                0 2px 5px 0 rgba(49, 49, 93, 0.1),
                0 1px 2px 0 rgba(0, 0, 0, 0.08);
            cursor: pointer;
            border: 1px solid color.scale(vars.$background-color, $lightness: 20%);
            background-color: color.scale(vars.$background-color, $lightness: 20%);
        }
    }
}

@media (max-width: 650px) {
    .toolbar {
        .username {
            display: none;
        }
    }
}

@media (max-width: 768px) {
    .toolbar {
        padding: 0 10px;

        .toggle-sidebar {
            display: block;
            opacity: 1;
        }

        .fullscreen-button {
            display: none;
        }
    }
}
</style>
